import { firebaseAuth } from '@/firebase/firebaseAuth'
import { signOut } from 'firebase/auth'

export default {
  logout () {
    signOut(firebaseAuth)
      .then()
      .catch((error) => console.error(`SingOut Error: ${error}`))
  }
}
